import { USERS_ENDPOINT } from 'common/constants/endpoints'
import { request } from 'common/utils'

import query from '../graphql/getUser.graphql'
import { GetUserQuery } from '../interfaces/schemaDefinition'

export const fetchUser: (userId: string) => Promise<GetUserQuery['user']> = async userId => {
  const variables = {
    id: userId,
  }
  const response = await request<GetUserQuery>(USERS_ENDPOINT, query, variables)
  return response.user
}
